import styled, { createGlobalStyle } from 'styled-components'
import 'antd-mobile-v2/dist/antd-mobile.css';

import 'antd/dist/antd.css';

export const GlobalStyle = createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  :root:root {
    --adm-color-primary: #36BEF1;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
    background:#f2f2f2;
    color:black;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  .font16{
    font-size:16px;
  }


  #loading{
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background:rgba(0,0,0,0.75);
    display:flex;
    justify-content:center;
    align-items:center;
    z-index:9999;
    font-size:20px;
  }
`

export const MainContainer = styled.div`
  width:100%;
  .topbox{
    position: fixed;
    top:0;
    width:100%;
    z-index:99;
  }
  .top-nav-bar{
    position: relative;
    background-color: #36BEF1;
    color: #FFF;
  }
  .icon{
    font-size:22px;
  }
  .marginTop16{
    margin-top: 16px;
  }
  .marginTop8{
    margin-top: 8px;
  }
  .marginBottom16{
    margin-bottom: 16px;
  }
  .marginBottom8{
    margin-bottom: 8px;
  }
  .margin8Auto{
    margin: 8px auto;
  }
  .marginAuto8{
    margin: auto 8px;
  }
`
